<template>
  <div>
    <el-dialog
      title="申请记录详情"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      width="1000px"
      height="1000px"
    >
      <div class="LoanDetails">
      <table border="1" cellpadding="0">
        <tbody>
          <tr>
            <td>主体类型</td>
            <td>{{ typesName }}</td>
            <td>统一社会信用代码</td>
            <td>{{ historyList.idCardNo }}</td>
          </tr>

          <tr>
            <td>法人姓名</td>
            <td>{{ historyList.legalPersonName }}</td>
            <td>法人身份证号</td>
            <td>{{ historyList.legalPersonNo }}</td>
          </tr>

          <tr>
            <td>地址</td>
            <td colspan="3">
              {{ historyList.area }}
            </td>
          </tr>

          <tr>
            <td>代理人</td>
            <td>{{ historyList.agentName }}</td>
            <td>代理人身份证号</td>
            <td>{{ historyList.agentNo }}</td>
          </tr>
          <tr>
            <td>手机号</td>
            <td>{{ historyList.phone }}</td>
          </tr>

          <tr>
            <td colspan="4"></td>
          </tr>
          <tr>
            <td>年经营收入</td>
            <td>{{ historyList.income }}</td>
            <td>实际经营年限</td>
            <td>{{ historyList.operatYear }}年</td>
          </tr>

          <tr>
            <td>经营内容</td>
            <td colspan="3">
              {{ historyList.operatIntorducation }}
            </td>
          </tr>

          <tr>
            <td colspan="4"></td>
          </tr>
          <tr>
            <td>贷款金额</td>
            <td colspan="3">{{ historyList.money }}元</td>
          </tr>
          <tr>
            <td>资金用途</td>
            <td colspan="3">{{ historyList.use }}</td>
          </tr>
          <tr v-if="historyList.loanTypeId==179 && historyList.orderId">
            <td>关联托管单</td>
            <td 
              class="clickable-td" 
              @click="handleViewContract('关联托管单')"
            >
              {{ historyList.orderName || historyList.orderId || '--' }}
            </td>
            <td 
              class="clickable-td" 
              @click="handleViewContract('流转合同')"
            >
              查看流转合同
            </td>
            <td 
              class="clickable-td" 
              @click="handleViewContract('托管合同')"
            >
              查看托管合同
            </td>
          </tr>
          <template v-if="historyList.loanTypeId==180 && historyList.warehouseId!=-1">
            <tr>
              <td>质押仓单</td>
              <td v-if="historyList.warehouseId==-1 && (historyList.status==3 || historyList.status==4)">
                待入库仓单
              </td>
              <td v-else
                class="clickable-td" 
                @click="handleViewContract('关联质押仓单')"
              >
                {{ historyList.warehouseCode || '--' }}
              </td>
              <td>质押数量</td>
              <td>{{ historyList.warehouseNumber||0 }} KG</td>
            </tr>
            <tr>
              <td>通过额度</td>
              <td>{{ historyList.approveMoney || 0 }} 万元</td>
              <td>贷款期限</td>
              <td>{{ historyList.loanTerm || 0 }} 个月</td>
            </tr>
            <tr>
              <td>放款账户</td>
              <td>{{ historyList.bankAccount}}</td>
              <td>账户名称</td>
              <td>{{ historyList.bankAccountName}}</td>
            </tr>
            <tr>
              <td>开户行</td>
              <td>{{ historyList.bankName}}</td>
              <td>已还本金</td>
              <td>{{ historyList.repaidMoney}} {{ historyList.repaidMoney?'元':''}}</td>
            </tr>
          </template>

          <tr>
            <td colspan="4"></td>
          </tr>

          <tr>
            <td>审批状态</td>
            <td>{{ statusName }}</td>
            <td>申请时间</td>
            <td>{{historyList.createTime}}</td>
          </tr>
        </tbody>
      </table>
      <!-- 营业执照 -->
      <div class="BusinessLicense">
        <div class="title">
          <p>营业执照<i>*</i></p>
        </div>
        <div class="textContent">
          <el-image
            :src="
              baseUrl + 'admin/file/get?ossFilePath=' + historyList.licenseImg
            "
            alt=""
          />
        </div>
      </div>
      <!-- 法人身份证 -->
      <div class="LegalPersonIDCard">
        <div class="title">
          <p>法人身份证人面像</p>
        </div>
        <div class="Left">
          <el-image :src="baseUrl + 'admin/file/get?ossFilePath=' +  historyList.userCardFrontImg" alt="" />
        </div>
        <div class="Right">
          <div class="title">
            <p>法人身份证国徽像</p>
          </div>
          <el-image :src="baseUrl + 'admin/file/get?ossFilePath=' + historyList.userCardBackImg" alt="" />
        </div>
      </div>
      <!-- 其他附件 -->
      <div class="OtherAccessories">
        <div class="title"><p>其他附件</p></div>
        <div class="textContent" v-if="historyList.files">
          <!-- accept="|.doc,.docx,.xls,.xlsx,.pdf,.zip,.7z" -->
          <div
            class="Item"
            v-for="(item, index) in JSON.parse(historyList.files)"
            :key="index"
          >
            <el-image :src="'/api/admin/file/get?ossFilePath=' + item.imgUrl">
              <div slot="error" class="image-slot">
                <i class="el-icon-document-copy"></i>
              </div>
            </el-image>
            <span>
              {{ item.FilesName }}
            </span>
          </div>
        </div>
        <div v-else class="textContent">暂无附件</div>
      </div>
    </div>
  </el-dialog>
  
  <!-- ShowDetail组件放在父对话框外部，避免z-index层级问题 -->
  <ShowDetail 
    v-if="showDetail" 
    @closeDialog2="closeDialog2" 
    ref="showDetail" 
    class="show-detail-overlay"
  />

  <InoutRecordDialog
    :visible="recordDialogVisible"
    :receipt-id="warehouseReceiptId"
    @update:visible="recordDialogVisible = $event"
  />

  <exportContract
      :visible="showExportContract"
      @close="showExportContract = false"
      :contractInfo="contractInfo"
      :contractArray="contractArray"
      :dialogType="2"
    />
    <TransferContractViewer 
      v-if="showContractViewer" 
      @closeDialog="showContractViewer = false" 
      ref="TransferContractRef" 
    />
  </div>
</template>

<script>
import { operateDetails } from "@/api/RuralFinance";
import ShowDetail from "@/views/memberCenter/tggl/wytg/showDetail.vue";
import { companyPusgPdf, orderPushPdf, selectLandDetail } from "../../../../api/add";
import ExportContract from "../../../chat/exportContract.vue";
import TransferContractViewer from "@/components/TransferContractViewer/index.vue";
import InoutRecordDialog from "@/views/memberCenter/warehousingService/warehouseReceiptManagement/InoutRecordDialog.vue";


export default {
  components: {
    InoutRecordDialog,
    ShowDetail,
    TransferContractViewer,
    ExportContract,
  },
  data() {
    return {
      recordDialogVisible: false, //质押仓单弹窗
      warehouseReceiptId: '', // 质押仓单id

      contractInfo: {},
      contractArray: [],
      showExportContract: false,
      dialogVisible: true,
      showDetail: false,
      showContractViewer: false,
      historyList: [],
      baseUrl: window.globalUrl.HOME_API,
      //申请状态
      statusType: [
        {
          label: "驳回",
          value: "-1",
        },
        {
          label: "草稿",
          value: "0",
        },
        {
          label: "审批中",
          value: "1",
        },
        {
          label: "通过",
          value: "2",
        },
        {
          label: "待放款",
          value: "3",
        },
        {
          label: "放款中",
          value: "4",
        },
        {
          label: "还款中",
          value: "5",
        },
        {
          label: "还款成功",
          value: "6",
        },
        {
          label: "还款异常",
          value: "7",
        },
      ],
      //主体类型
      types: [
        {
          label: "集体经济组织",
          value: "3",
        },
        {
          label: "农业企业",
          value: "41",
        },
        {
          label: "家庭农场",
          value: "42",
        },
        {
          label: "合作社",
          value: "43",
        },
      ],
      //主体类型名字
      typesName: "",
      statusName: "",
    };
  },

  mounted() {},

  methods: {
    handleClose(done) {
      this.$emit("closeDialog", false);
    },
    // back() {
    //   this.$emit("closeDialog", false);
    // },

    //回显详情数据
    async init(val) {
      // console.log(val,"传过来的")
      let params = {
        applyId: val,
      };
      let res = await operateDetails(params);
      this.historyList = res.data;
      let Value = this.historyList.userType;
      let Value2 = this.historyList.status;
      let label = "";
      let label2 = "";
      this.types.filter((item, index) => {
        if (Value == item.value) {
          return (label = item.label);
        }
      });
      this.typesName = label;
      this.statusType.filter((item, index) => {
        if (Value2 == item.value) {
          return (label2 = item.label);
        }
      });
      console.log(this.statusName);
      this.statusName = label2;
    },

    // 通用的弹窗管理方法
    async showDialog(dialogName, initData = null) {
      try {
        // 设置对应弹窗显示状态
        this[dialogName] = true;
        
        // 等待组件渲染完成
        await this.$nextTick();
        
        // 如果有初始化数据且组件存在，则初始化
        if (initData && this.$refs[dialogName]) {
          this.$refs[dialogName].init(initData);
        }
      } catch (error) {
        console.error(`显示${dialogName}弹窗失败:`, error);
        this[dialogName] = false;
      }
    },

    // 通用的弹窗关闭方法
    closeDialog(dialogName) {
      this[dialogName] = false;
    },

    // 处理合同查看点击事件
    handleViewContract(contractType) {
      console.log('点击查看合同:', contractType);
      
      // 使用策略模式优化分支逻辑
      const contractHandlers = {
        '流转合同': this.viewTransferContract,
        '托管合同': this.viewCustodyContract,
        '关联托管单': this.handleHost,
        '关联质押仓单': this.handleWarehouseReceipt,
      };

      const handler = contractHandlers[contractType];
      if (handler) {
        handler.call(this);
      } else {
        console.warn(`未知的合同类型: ${contractType}`);
        this.$message.warning(`暂不支持查看${contractType}`);
      }
    },

    //质押仓单详情
    async handleWarehouseReceipt() {
      if (!this.historyList.warehouseId||this.historyList.warehouseId==-1) {
        this.$message.warning('质押仓单ID不存在');
        return;
      }
      try {
        this.recordDialogVisible = true;
        await this.$nextTick();
        this.warehouseReceiptId = String(this.historyList.warehouseId || -1);
      } catch (error) {
        console.error(`仓单弹窗失败:`, error);
        this.recordDialogVisible = false;
      }
    },

    // 关闭详情弹窗
    closeDialog2(){
      this.showDetail = false;
    },

    // 查看托管详情（优化版本）
    async handleHost(){
      if (!this.historyList.orderId) {
        this.$message.warning('订单ID不存在');
        return;
      }

      const params = {
        orderId: this.historyList.orderId,
      };

      try {
        // await this.showDialog('showDetail', params);
        const res = await selectLandDetail(params);
        
        if (res.code === 0) {
          // 使用通用弹窗管理方法
          await this.showDialog('showDetail', {...res.data, orderId:this.historyList.orderId});
        } else {
          this.$message.error(res.msg || '获取详情失败');
        }
      } catch (error) {
        console.error('获取托管详情失败:', error);
        this.$message.error(error.message || '网络请求失败');
      }
    },

    // 查看流转合同（新版本）
    viewTransferContract() {
      console.log('查看流转合同详情（新版本）');
      
      // 检查是否有合同数据
      if (!this.historyList || !this.historyList.contractPicList || !this.historyList.contractPicList.length) {
        this.$message.warning('暂无合同数据');
        return;
      } else {
        // 有合同数据，正常显示
        console.log('合同数据：', this.historyList.contractPicList);
        this.showContractViewer = true;
        this.$nextTick(() => {
          console.log('初始化合同查看器（真实数据）');
          if (this.$refs.TransferContractRef) {
            this.$refs.TransferContractRef.init(this.historyList.contractPicList);
          } else {
            console.error('TransferContractRef 引用不存在');
          }
        });
      }
    },

    // 查看托管合同
    async viewCustodyContract() {
      // 这里可以打开新窗口、弹框或者跳转页面
      console.log('查看托管合同详情');
      let params = {
        orderId: this.historyList.orderId,
      };
      try {
        let res = await orderPushPdf(params);
        this.contractInfo = res;
        this.showExportContract = true;
      } catch (error) {
        console.log(error,'error');
      }
    },
  },
};
</script>

<style lang="less" scoped>
.LoanDetails {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  table {
    width: 100%;
    height: 100%;
    border-collapse: collapse;
    tr {
      td {
        width: 80px;
        height: 30px;
        text-align: center;
        
        // 可点击的td样式
        &.clickable-td {
          cursor: pointer;
          font-weight: bold;
          padding: 8px 12px;
          border-radius: 4px;
          transition: all 0.3s ease;
          user-select: none;
          color: #409EFF;
          
          &:hover {
            transform: translateY(-1px);
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
          }
          
          &:active {
            transform: translateY(0);
          }
        }
      }
    }
  }
  /*营业执照*/
  .BusinessLicense {
    display: flex;
    border: solid 1px #ccc;
    padding: 10px;
    .title {
      width: 10%;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      p {
        font-size: 15px;
        font-weight: bold;
        text-align: center;
      }
    }
    .textContent {
      width: 48%;
      display: flex;
      justify-content: space-around;
      padding-left: 10px;
      /deep/.el-image {
        img {
          width: 200px;
          height: 100px;
          padding: 5px 0px;
        }
        .image-slot {
          img {
            width: 100px;
            height: 80px;
          }
        }
      }
      img {
        width: 200px;
        height: 100px;
      }
      p {
        width: 94px;
        height: 100px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
      }
    }
  }
  /*法人身份证*/
  .LegalPersonIDCard {
    display: flex;
    border: solid 1px #ccc;
    padding: 10px;
    .title {
      width: 10%;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      p {
        font-size: 15px;
        font-weight: bold;
        text-align: center;
        i {
          color: red;
        }
      }
    }
    .Left {
      width: 50%;
      display: flex;
      padding-left: 50px;
      justify-content: space-around;
      /deep/.el-image {
        img {
          width: 200px;
          height: 100px;
          padding: 5px 0px;
        }
        .image-slot {
          img {
            width: 100px;
            height: 80px;
          }
        }
      }

      p {
        width: 94px;
        height: 100px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
      }
      .title {
        font-size: 15px;
        font-weight: bold;
      }
    }
    .Right {
      width: 50%;
      display: flex;
      justify-content: space-around;
      /deep/.el-image {
        img {
          width: 200px;
          height: 100px;
          padding: 5px 0px;
        }
        .image-slot {
          img {
            width: 100px;
            height: 80px;
          }
        }
      }
      p {
        width: 94px;
        height: 100px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
      }
      .title {
        font-size: 15px;
        font-weight: bold;
      }
    }
  }
  /*其他附件*/
  .OtherAccessories {
    border: solid 1px #ccc;
    display: flex;
    .title {
      width: 10%;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      p {
        font-size: 15px;
        font-weight: bold;
        text-align: center;
        i {
          color: red;
        }
      }
    }
    .textContent {
      width: 100%;
      height: 120px;
      display: flex;
      border: solid 1px #ccc;
      .Item {
        width: 150px;
        height: 100%;
        display: flex;
        flex-direction: column;
        text-align: center;
        position: relative;
        padding: 10px;
        .el-image {
          width: 150px;
          height: 85px;
          background: #e6e3e3;
          img {
            width: 200px;
            height: 50px;
          }
          i {
            font-size: 50px;
            font-weight: bold;
            margin-top: 20px;
          }
        }
        span {
          margin-top: 5px;
        }
        .del {
          width: 20px;
          height: 20px;
          border: solid 1px black;
          border-radius: 50px;
          display: none;
          position: absolute;
          right: 0;
          top: 0;
          z-index: 5000;
          text-align: center;
          line-height: 20px;
        }
      }
      .Item:hover {
        .del {
          display: block;
        }
      }
      .upload-demo {
        i {
          font-size: 50px;
          font-weight: bold;
          margin-top: 30px;
        }
      }
    }
  }
}

/* 确保ShowDetail组件显示在最顶层 */
.show-detail-overlay {
  z-index: 3000 !important;
}

/* 全局样式：确保ShowDetail的遮罩层有足够高的z-index */
/deep/ .show-detail-overlay .el-dialog__wrapper {
  z-index: 3000 !important;
}

/deep/ .show-detail-overlay .el-overlay {
  z-index: 2999 !important;
}
</style>
